import React from "react"
import avatar from "avatar/nuno-sad.svg"

const NunoSad = (props) => <img src={avatar} className="avatar" {...props} />

export default NunoSad
